import React, { useEffect, useRef } from "react";

export const TranscriptPanel = ({ lines = [], partial = "", emptyText = "Henüz metin yok.", testId, maxHeight = "200px" }) => {
  const endRef = useRef(null);
  useEffect(() => {
    if (endRef.current) endRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }, [lines, partial]);

  const empty = lines.length === 0 && !partial;
  return (
    <div
      data-testid={testId}
      className="overflow-y-auto rounded-[calc(var(--radius)-4px)] border border-border/70 bg-secondary/40 p-3"
      style={{ maxHeight, minHeight: "110px" }}
    >
      {empty ? (
        <p className="text-sm text-muted-foreground">{emptyText}</p>
      ) : (
        <div className="space-y-2">
          {lines.map((l, i) => (
            <p key={i} className="text-sm leading-relaxed text-foreground">{l}</p>
          ))}
          {partial && (
            <p className="text-sm leading-relaxed text-[hsl(var(--accent))]">
              {partial}
              <span className="ml-0.5 inline-block h-3.5 w-[2px] animate-pulse bg-[hsl(var(--accent))] align-middle" />
            </p>
          )}
          <div ref={endRef} />
        </div>
      )}
    </div>
  );
};
